<template>
  <div class="home">
    <div class="search">
      <div class="search1">
        <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
          <van-swipe-item><img style="width:100%;" src="../../assets/home1.jpg"/></van-swipe-item>
          <van-swipe-item><img style="width:100%;" src="../../assets/home2.jpg"/></van-swipe-item>
        </van-swipe>
      </div>
      <!-- <div class="search2">
        <aboutSearch></aboutSearch>
      </div> -->
    </div>
    <div class="navDiv">
      <lz-menu />
      <!-- <div class="navDivList" style="margin-left: .4rem;">
        <a href="/myyq">
          <div class="navImg">
            <img src="../../assets/yuanqu.jpg" />
          </div>
          <div class="txt">
            墓园园区
          </div>
        </a>
      </div>
      <div class="navDivList">
        <a href="/beixing">
          <div class="navImg">
            <img src="../../assets/home21.jpg" />
          </div>
          <div class="txt"><i class="iconfont" style="color:#ff0000;">&#xe646;</i>碑型推荐</div>
        </a>
      </div>
      <div class="navDivList">
        <a href="/jdz">
          <div class="navImg">
            <img src="../../assets/jiedi.jpg" />
          </div>
          <div class="txt">
            节地生态葬
          </div>
        </a>
      </div> -->
    </div>
    <div class="muqu">
      <div class="header">
        <div class="line">
          <span>碑型推荐</span>
        </div>
      </div>
      <div class="htitle">
        安息者的净土 往生者的天堂
      </div>
      <div class="list">
        <div class="listContent">
          <div class="item" v-for="(item, index) in stele_list" :key="index">
            <a :href="'/bxDetail/' + item.id">
              <div class="top">
                <div class="img">
                  <div class="imgDiv">
                    <img :src="item.firstPhoto" />
                  </div>
                </div>
                <div class="content">
                  <div class="title">{{ item.oweArea.areaName }} {{ item.steleName }}</div>
                  <div class="tag">
                    {{ $join(item.labels, ' | ') }}
                  </div>
                  <div class="zixun">
                    咨询价格
                  </div>
                </div>
              </div>
              <div class="bottom">
                <span>已被咨询{{ item.consultCount }}次</span>
                <span>在售墓地{{ item.tombCount }}个</span>
              </div>
            </a>
          </div>
        </div>
      </div>
      <a href="/beixing">
        <div class="more">查看更多</div>
      </a>
    </div>
    <div class="jiedi">
      <div class="header">
        <div class="line">
          <span>节地生态葬</span>
        </div>
      </div>
      <div class="htitle">
        让生命在自然中回归
      </div>
      <div class="list">
        <div class="listContent">
          <a :href="'/jdz#' + item.id" v-for="(item, index) in natural_list" :key="index">
            <div class="item">
              <div class="img">
                <img :src="item.homePhoto" />
              </div>
              <div class="content">
                {{ item.homeBrief }}
              </div>
            </div>
          </a>
        </div>
      </div>
      <a href="/jdz">
        <div class="more">查看更多</div>
      </a>
    </div>
    <div class="guanjia">
      <div class="header">
        <div class="line">
          <span>行业知识</span>
        </div>
      </div>
      <!-- <div class="htitle">
        专业团队 专业导购
      </div> -->
      <div class="list">
        <div class="list-news">
          <template>
            <a v-for="(item, index) in list" :href="getHref(item.id, item.category)" :key="index">
              <div class="content">
                <div class="img">
                  <img
                    class="van-image__img"
                    data-src="../../../assets/search2.jpg"
                    :src="item.firstPhoto"
                    lazy="loaded"
                    style="object-fit: cover;"
                  />
                </div>
                <div class="title">
                  {{ item.title }}
                </div>
              </div>
            </a>
          </template>
        </div>
      </div>
      <router-link :to="{ path: '/news', name: 'news', params: { type: 1 } }" tag="div">
        <div class="more">查看更多</div>
      </router-link>
    </div>
    <!-- <van-action-sheet v-model="show" title="购墓预约">
      <div class="content">
        
        <iframe src="/shopgmdjgw" frameborder="0" style="height:10rem;width:100%;"></iframe>
      </div>
    </van-action-sheet>
    <div class="foot1">
      <div class="footMenu1">
        <div class="div0">
          <div class="div1"><i class="iconfont">&#xe679;</i>电话咨询</div>
          <div class="div2"><i class="iconfont">&#xe62f;</i>在线客服</div>
        </div>
        <div class="div3" @click="show = true"><i class="iconfont">&#xe60d;</i> 购墓预约</div>
      </div>
    </div> -->
  </div>
</template>

<script>
//import aboutSearch from './Search'
import LzMenu from './Menu.vue'
// import goumudengji from '../shop/Gmdj'
export default {
  name: 'abouthome',
  components: {
    //aboutSearch,
    LzMenu
    // goumudengji
  },
  data() {
    return {
      flag: false,
      path: 'index',
      show: false,
      dataList: [
        {
          title: '万寿墓',
          tag: '花岗岩石 | 中国黑碑',
          zixun: '600',
          num: '100',
          img: '../../assets/jingguan2.jpg',
          id: 1,
        },
        {
          title: '吉祥墓',
          tag: '花岗岩石 ',
          zixun: '600',
          num: '100',
          img: '../../assets/jingguan2.jpg',
          id: 2,
        },
        {
          title: '万寿墓',
          tag: '花岗岩石 | 中国黑碑',
          zixun: '600',
          num: '100',
          img: '../../assets/jingguan2.jpg',
          id: 3,
        },
        {
          title: '吉祥墓',
          tag: '花岗岩石 ',
          zixun: '600',
          num: '100',
          img: '../../assets/jingguan2.jpg',
          id: 4,
        },
      ],
      dataListJiedi: [
        {
          id: 'shuzang',
          content:
            '树葬是目前殡葬改革中的一种全新方式，还是人们用来悼念的一种方式。 它既满足了人们的传统观念，入土为安，也是通过将逝者与树融为一体，使其生命得以延续，得到升华。 树葬是将逝者骨灰盒放入套盒内，封盖、封土，立卧碑，墓穴边角种一棵松柏树，根据面积，可自行决定种植其他树木花草。',
          img: '../../assets/jingguan2.jpg',
        },
        {
          id: 'huazang',
          content:
            'dfdfdf树葬是目前殡葬改革中的一种全新方式，还是人们用来悼念的一种方式。 它既满足了人们的传统观念，入土为安，也是通过将逝者与树融为一体，使其生命得以延续，得到升华。 树葬是将逝者骨灰盒放入套盒内，封盖、封土，立卧碑，墓穴边角种一棵松柏树，根据面积，可自行决定种植其他树木花草。dfdf',
          img: '../../assets/jingguan2.jpg',
        },
        {
          id: 'caopingzang',
          content:
            'dfdfdf树葬是目前殡葬改革中的一种全新方式，还是人们用来悼念的一种方式。 它既满足了人们的传统观念，入土为安，也是通过将逝者与树融为一体，使其生命得以延续，得到升华。 树葬是将逝者骨灰盒放入套盒内，封盖、封土，立卧碑，墓穴边角种一棵松柏树，根据面积，可自行决定种植其他树木花草。dfdf',
          img: '../../assets/jingguan2.jpg',
        },
        {
          id: 'bizang',
          content:
            'dfdfdf树葬是目前殡葬改革中的一种全新方式，还是人们用来悼念的一种方式。 它既满足了人们的传统观念，入土为安，也是通过将逝者与树融为一体，使其生命得以延续，得到升华。 树葬是将逝者骨灰盒放入套盒内，封盖、封土，立卧碑，墓穴边角种一棵松柏树，根据面积，可自行决定种植其他树木花草。dfdf',
          img: '../../assets/jingguan2.jpg',
        },
      ],
      dataListGuanjia: [
        {
          xingming: '张三',
          tag: ['专业', '沉稳'],
          img: '../../assets/ren.jpg',
        },
        {
          xingming: '李四',
          tag: ['专业', '沉稳', '热情'],
          img: '../../assets/ren.jpg',
        },
        {
          xingming: '张一',
          tag: ['专业', '沉稳'],
          img: '../../assets/ren.jpg',
        },
        {
          xingming: '张二',
          tag: ['专业', '沉稳', '服务贴心'],
          img: '../../assets/ren.jpg',
        },
      ],
      stele_list: [],
      natural_list: [],
      guider_list: [],
      list: [],
    }
  },
  created() {
    this.querySteleAll()
    this.queryNaturalAll()
    this.queryGuiderAll()
    this.getDataNews()
  },
  methods: {
    getHref(id, category) {
      return '/newsDetail/' + category.value + '/' + id
    },
    getDataNews() {
      var that = this
      this.$queryPage(
        'OweDynamic',
        { category: 'industry', page: 1, size: 5, sort: { browserCount: 0 } },
        ['id,category,title,firstPhoto,createDate,browserCount'],
        function(res) {
          if (res.data.length > 0) {
            res.data.forEach(item => {
              that.list.push(item)
            })
          }
        }
      )
    },
    querySteleAll() {
      var that = this
      this.$queryAll(
        'OweStele',
        { size: 3 },
        ['id', 'oweArea.areaName', 'firstPhoto', 'steleName', 'labels', 'consultCount', 'tombCount'],
        function(res) {
          that.$fill(that.stele_list, res['data'])
        }
      )
    },
    queryNaturalAll() {
      var that = this
      this.$queryAll(
        'OweNatural',
        { sort: { orderNum: 1 } },
        ['id', 'homePhoto', 'homeBrief'],
        function(res) {
          that.$fill(that.natural_list, res['data'])
        }
      )
    },
    queryGuiderAll() {
      var that = this
      this.$queryPage(
        'OweGuider',
        { size: 4 },
        ['id', 'userName', 'firstPhoto', 'introduce', 'labels'],
        function(res) {
          that.$fill(that.guider_list, res['data'])
        }
      )
    },
    menuClick(url) {
      this.path = url
    },
  },
}
</script>

<style>
.home .search {
  height: 3rem;
  position: relative;
}
.home .search2 {
  position: absolute;
  top: 40%;
  width: 100%;
}
.home .my-swipe .van-swipe-item {
  height: 4rem;
}
/* .home .navDiv {
  display: flex;
  margin-top: 1.6rem;
  height: unset !important;
} */
.home .navImg {
  height: 3rem;
}
/* .home .navDivList {
  margin-right: 0.53rem;
  flex-shrink: 0;
  position: relative;
  border-radius: 0.16rem;
  overflow: hidden;
}
.home .navDivList .txt {
  text-align: center;
  font-size: 0.37333rem;
  font-weight: 500;
  color: #333;
  line-height: 0.53rem;
}
.home .navDivList img {
  width: 2.7rem;
  height: 2.7rem;
  border-radius: 0.16rem;
  overflow: hidden;
  margin-bottom: 0.27rem;
} */
.home .muqu {
  background: #faf9f7;
  padding-top: 0.4rem;
  margin-top: 0.6rem;
}
.home .muqu .line {
  font-size: 0.53rem;
  color: #dea767;
  line-height: 0.75rem;
  position: relative;
  font-weight: 600;
}
.home .muqu .list {
  margin-top: 0.4rem;
}
.home .list-news a {
  display: block;
  padding: 0.1rem 0;
}
.home .list-news {
  padding: 0.67rem 0 0.27rem;
  border-bottom: 0.027rem solid #dfdfdf;
}
.home .list-news .img {
  width: 100%;
  height: 3rem;
}
.home .list-news .img img {
  width: 100%;
  border-radius: 5px;
}
.home .list-news .title {
  font-size: 0.42667rem;
      text-align: left;

  color: #333;
  line-height: 0.61333rem;
  margin-bottom: 0.13333rem;
  margin-top: 0.3rem;
}
.home .list-news .time {
  font-size: 0.37333rem;
  color: #666;
  line-height: 0.53rem;
}
.home .muqu .line::after {
  content: '';
  width: 1.06667rem;
  height: 0.027rem;
  background: #dea767;
  opacity: 0.2;
  position: absolute;
  top: 0.32rem;
  right: -1.33rem;
}
.home .muqu .line::before {
  content: '';
  width: 1.06667rem;
  height: 0.027rem;
  background: #dea767;
  opacity: 0.2;
  position: absolute;
  top: 0.32rem;
  left: -1.33rem;
}

.home .muqu .header {
  font-size: 0.36rem;

  color: #dea767;
  display: flex;
  justify-content: center;
}
.home .muqu .header i {
  font-size: 1rem;
  color: #ccc;
  line-height: 1rem;
}
.home .muqu .content {
  width: 5.46667rem;
}
.home .htitle {
  font-size: 0.37333rem;
  color: #666;
  line-height: 0.53rem;
  display: block;
  margin-top: 0.13333rem;
  margin-bottom: 0.43rem;
}
.home .muqu .title {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 0.42667rem;
  font-weight: 500;
  color: #333;
  line-height: 0.61333rem;
  margin-bottom: 0.13333rem;
}
.home .muqu .tag {
  margin-bottom: 0;
  font-size: 0.32rem;
  color: #666;

  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;

  word-wrap: break-word;

  word-break: break-all;
  width: 4.1rem;
}
.home .muqu .item {
  padding: 0.1rem 0.4rem;

  height: 4rem;
}

.home .muqu .item .top {
  display: flex;
}
.home .muqu .item .top .content {
  position: relative;
  padding: 0 0.2rem;
  flex: 1;
}
.home .muqu .item .top .content .zixun {
  font-size: 0.37333rem;
  color: #dea767;
  line-height: 0.53rem;
  position: relative;
  display: inline;
}
.home .muqu .item .top .content .zixun::after {
  content: '';
  width: 0.13333rem;
  height: 0.18667rem;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAcBAMAAACT9IJTAAAALVBMVEUAAAD/v3//zJn/qn/fqGffqWnfp2jeqGffqGffp2jfqGffqGjfp2jep2fep2djMZ0yAAAADnRSTlMABAUGT1Cpqq2ur7Cx+ksIhDEAAAB8SURBVBjTY2BgLWKAgdhXClAW6713i6BM33fvXkOF8969e7cJwtR6BxdmWocQ1kQSngdkH0IIv0ESPgwR1gAJG0CE+7AK6wCZLwTACs4BmY1gQW2QINg0pn1AZhNc8CVCcBLclVDBdVgEwR6aBPX7u3cw3yN5HilIEAEFAPLwX7r0H2r8AAAAAElFTkSuQmCC)
    no-repeat 50%/100% 100%;
  position: absolute;
  right: -0.27rem;
  top: 50%;
  transform: translateY(-50%);
}

.home .muqu .item .top .img {
  width: 3.46667rem;
  height: 2.34667rem;
  border-radius: 0.05333rem;
  overflow: hidden;
}
.home .muqu .item .top .imgDiv {
  width: 100%;
  height: 100%;

  position: relative;
  display: inline-block;
}
.home .muqu .item .top .img img {
  width: 100%;
  object-fit: cover;
  height: 100%;
}
.home .muqu .item .bottom {
  border-bottom: 0.02rem solid #dfdfdf;
  font-size: 0.32rem;
  color: #666;
  line-height: 0.7rem;
  margin-top: 0;

  display: flex;
  justify-content: space-between;
  height: 0.7rem;
}
.home .muqu .item .content {
  position: relative;
  color: #666;
  font-size: 0.28rem;
}
.home .muqu .item .bottom .content {
  position: relative;
}
.home .muqu .item .bottom .left {
  position: absolute;
  left: 0;
}
.home .muqu .item .bottom .right {
  position: absolute;
  right: 0;
}
.home .muqu .item .top .content {
  text-align: left;
}
.home .jiedi {
  padding: 0.67rem 0.4rem;
}
.home .jiedi .content {
  font-size: 0.37333rem;
  color: #666;
  line-height: 0.53rem;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.home .jiedi .item {
  width: 9.2rem;
  height: 6.3rem;
  border-radius: 0.05333rem;
  overflow: hidden;
  margin-bottom: 0.6667rem;
}
.home .jiedi .list .img {
  width: 9.2rem;
  height: 4.8rem;
  border-radius: 0.05333rem;
  overflow: hidden;

  position: relative;
  display: inline-block;
}
.home .jiedi .list .img img {
  display: block;
  width: 100%;
  height: 100%;
}
.home .jiedi .list .item .content {
  text-align: left;
  padding: 0.1rem 0.2rem;
}
.home .jiedi .header {
  font-size: 0.36rem;

  color: #dea767;
  display: flex;
  justify-content: center;
}
.home .jiedi .line {
  font-size: 0.53rem;
  color: #dea767;
  line-height: 0.75rem;
  position: relative;
  font-weight: 600;
}
.home .jiedi .line::after {
  content: '';
  width: 1.06667rem;
  height: 0.027rem;
  background: #dea767;
  opacity: 0.2;
  position: absolute;
  top: 0.32rem;
  right: -1.33rem;
}
.home .jiedi .line::before {
  content: '';
  width: 1.06667rem;
  height: 0.027rem;
  background: #dea767;
  opacity: 0.2;
  position: absolute;
  top: 0.32rem;
  left: -1.33rem;
}
.home .jiedi .htitle {
  font-size: 0.37333rem;
  color: #666;
  line-height: 0.53rem;
  display: block;
  margin-top: 0.13333rem;
  margin-bottom: 0.43rem;
}
/*  */
.home .guanjia {
  padding: 0.67rem 0.4rem;
  background: #faf9f7;
  margin-bottom: 0.5rem;
}
.home .guanjia .content {
  font-size: 0.37333rem;
  color: #666;
  line-height: 0.53rem;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.home .guanjia .item {
  width: 4.26667rem;
  border-radius: 0.05333rem;
  overflow: hidden;
  margin-right: 0.64rem;
  margin-bottom: 0.3rem;
}
.home .guanjia .item .tag {
  margin-top: 0.1rem;
}
.home .guanjia .item .tag span {
  display: inline-block;
  padding: 0.027rem 0.10667rem;
  background: #fbf6ef;
  border-radius: 0.05333rem;
  font-size: 0.32rem;
  color: #dea767;
  margin-right: 0.10667rem;
}
.home .guanjia .item:nth-child(2n) {
  margin-right: 0;
}
/* .home .guanjia .list .img {
  width: 9.2rem;
  height: 4.8rem;
  border-radius: 0.05333rem;
  overflow: hidden;

  position: relative;
  display: inline-block;
} */
/* .home .guanjia .list .img img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
} */
.home .guanjia .list .item .content {
  text-align: left;
  padding: 0.1rem 0.2rem;
}
.home .guanjia .header {
  font-size: 0.36rem;

  color: #dea767;
  display: flex;
  justify-content: center;
}
.home .guanjia .line {
  font-size: 0.53rem;
  color: #dea767;
  line-height: 0.75rem;
  position: relative;
  font-weight: 600;
}
.home .guanjia .line::after {
  content: '';
  width: 1.06667rem;
  height: 0.027rem;
  background: #dea767;
  opacity: 0.2;
  position: absolute;
  top: 0.32rem;
  right: -1.33rem;
}
.home .guanjia .listContent {
  display: flex;
  flex-wrap: wrap;
}
.home .guanjia .line::before {
  content: '';
  width: 1.06667rem;
  height: 0.027rem;
  background: #dea767;
  opacity: 0.2;
  position: absolute;
  top: 0.32rem;
  left: -1.33rem;
}
.home .guanjia .htitle {
  font-size: 0.37333rem;
  color: #666;
  line-height: 0.53rem;
  display: block;
  margin-top: 0.13333rem;
  margin-bottom: 0.43rem;
}
/*  */
.home .foot1 {
  height: 1.5rem;
  background: #fff;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 999;
  width: 100%;
  padding: 0.3rem 0.5rem 0 0.5rem;
}
.home .footMenu1 {
  height: 0.9rem;
  background: #fff;

  padding: 0.21333rem 0.4rem;
  justify-content: space-between;

  display: flex;
  align-items: center;
  color: #dea767;
  position: relative;
}
.home .footMenu1 .div1 {
  color: #fff;

  padding: 0.1rem 0.3rem;

  border-right: 0.02rem solid #fff;
}
.home .footMenu1 .div2 {
  color: #fff;

  padding: 0.1rem 0.3rem;
}
.home .footMenu1 .div0 {
  position: absolute;
  background: #dea767;
  left: 0;
  width: 5.1rem;
  border-radius: 50rem;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.home .footMenu1 .div3 {
  position: absolute;
  right: 0;
  border: #dea767 0.02rem solid;
  color: #dea767;
  background: #fff;
  border-radius: 50rem;
  padding: 0.1rem 0.3rem;
}
.home .footMenu1 .left {
  width: 2.93rem;
  height: 1.17333rem;
}
.home .footMenu1 .left div,
.home .footMenu1 .right div {
  display: block;
  width: 2.93rem;
  height: 1.17333rem;
  line-height: 1.17333rem;
  padding-left: 0.96rem;
  color: #333;
  font-size: 0.37333rem;
}
.home .footMenu1 .right {
  width: 5.94667rem;
  height: 1.17333rem;
  background: #fff;
  border-radius: 0.58667rem;
  overflow: hidden;
  border: 0.027rem solid #dea767;
  display: flex;
  justify-content: space-between;
}
.home .more {
  display: block;
  padding-bottom: 0.23rem;
  text-align: center;
  font-size: 0.32rem;
  color: #dea767;
  line-height: 0.45333rem;
}
</style>
